
export default [
  {
    path: "/summary",
    component: () => import("../views/home/summary"),
    // meta: { title: global.productName }
  }
];
